import { render } from "./ProductInfo.vue?vue&type=template&id=9e3a9738&scoped=true"
import script from "./ProductInfo.js?vue&type=script&lang=js"
export * from "./ProductInfo.js?vue&type=script&lang=js"

import "./ProductInfo.scss?vue&type=style&index=0&id=9e3a9738&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3a9738"]])

export default __exports__